import React from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { NeighborhoodMap } from './components/NeighborhoodMap';
import { ComeFunzionaSection } from './components/ComeFunzionaSection';
import { MaintenanceSection } from './components/MaintenanceSection';
import { CtaSection } from './components/CtaSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen flex flex-col w-full bg-page-bg" data-id="element-0">
      <Navbar data-id="element-1" />

      <main className="flex-grow flex flex-col w-full" data-id="element-2">
        <HeroSection data-id="element-3" />

        <NeighborhoodMap data-id="element-4" />

        <ComeFunzionaSection data-id="element-5" />

        <MaintenanceSection data-id="element-6" />

        <CtaSection data-id="element-7" />
      </main>

      <Footer data-id="element-8" />
    </div>;
}